import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { supabase } from "@/integrations/supabase/client";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format } from "date-fns";

export function AdminQaAuditTab() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data, error } = await (supabase.rpc as any)("list_qa_audit", { p_limit: 200 });
      setLoading(false);
      if (!error) setRows(data ?? []);
    })();
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle>QA Audit Log</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="text-sm text-muted-foreground">No QA events recorded yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Actor</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Assessment</TableHead>
                <TableHead>Env</TableHead>
                <TableHead>Details</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="text-xs whitespace-nowrap">
                    {format(new Date(r.created_at), "MMM d, p")}
                  </TableCell>
                  <TableCell className="text-xs font-mono">{r.user_id?.slice(0, 8)}</TableCell>
                  <TableCell>
                    <Badge variant="outline">{r.action}</Badge>
                  </TableCell>
                  <TableCell className="text-xs font-mono">{r.assessment_id?.slice(0, 8) ?? "—"}</TableCell>
                  <TableCell className="text-xs">{r.environment ?? "—"}</TableCell>
                  <TableCell className="text-xs max-w-xs truncate">
                    {JSON.stringify({ before: r.before_state, after: r.after_state, meta: r.metadata })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
